module.exports = __webpack_public_path__ + "img/minigolf_opt.03047801.jpg";